module.exports = __webpack_public_path__ + "img/campus.dfcb3aa1.png";